module.exports = __webpack_public_path__ + "img/add-card-about-1.ba9d1c6f.png";